import type { AdminAlert, ClinicalAlert } from "@/types/wizard";

type Props = {
  admin: AdminAlert[];
  clinical: ClinicalAlert[];
};

export function AlertsPanel({ admin, clinical }: Props) {
  if (admin.length === 0 && clinical.length === 0) {
    return (
      <div className="alert-inline alert-inline--success alert-inline--md alert-inline--bold">
        ✅ Sin alertas detectadas. El paciente puede proceder a cirugía.
      </div>
    );
  }
  return (
    <div className="alerts-list">
      {admin.map((a, i) => (
        <div key={`a-${i}`} className={`alert-item alert-item--admin alert-item--${a.severidad}`}>
          <div className="alert-item-title">📋 {a.titulo}</div>
          {a.evidence && <div className="alert-item-evidence"><b>Dato que la disparó:</b> {a.evidence}</div>}
          <div className="alert-item-meta"><b>Tipo:</b> Administrativa · <b>Severidad:</b> {a.severidad}</div>
          <div className="alert-item-meta"><b>Conducta:</b> {a.accion}</div>
        </div>
      ))}
      {clinical.map((a, i) => (
        <div key={`c-${i}`} className={`alert-item alert-item--clinical alert-item--${a.clasificacion}`}>
          <div className="alert-item-title">
            {a.clasificacion === "negociable" ? "🟡" : "🔴"} {a.titulo}
          </div>
          {a.evidence && <div className="alert-item-evidence"><b>Dato que la disparó:</b> {a.evidence}</div>}
          <div className="alert-item-meta"><b>Tipo:</b> Clínica · <b>Clasificación:</b> {a.clasificacion}</div>
          <div className="alert-item-meta"><b>Conducta:</b> {a.accion}</div>
        </div>
      ))}
    </div>
  );
}
